import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  Button,
  CircularProgress,
  Tabs,
  Tab,
  Chip,
  Card,
  CardContent,
  Avatar,
  Divider,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Alert,
  LinearProgress,
  Badge,
  Container,
  Stack,
  IconButton,
  Tooltip,
  Fade,
  Zoom,
  InputAdornment,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import PersonIcon from "@mui/icons-material/Person";
import EmailIcon from "@mui/icons-material/Email";
import HomeIcon from "@mui/icons-material/Home";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import GroupIcon from "@mui/icons-material/Group";
import WorkIcon from "@mui/icons-material/Work";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import VerifiedIcon from "@mui/icons-material/Verified";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import InfoIcon from "@mui/icons-material/Info";
import BadgeIcon from "@mui/icons-material/Badge";
import FamilyRestroomIcon from "@mui/icons-material/FamilyRestroom";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PetsIcon from "@mui/icons-material/Pets";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import DescriptionIcon from "@mui/icons-material/Description";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import Wrapper from "../../../components/Wrapper";
import { useState, useEffect, useCallback } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import title from "../../../components/title";
import { useSelector, useDispatch } from "react-redux";
import { GetTenant } from "../../../redux/reducer/GetTenantDetail";
import { GetAccount } from "../../../redux/reducer/GetAccountDetails";
import {
  GetLandlordInterestRequests,
  UpdateInterestRequestStatus,
  ConfirmMoveIn,
} from "../../../redux/reducer/FlatInterestRequest";
import Swal from "sweetalert2";
import moment from "moment";
import axios from "axios";
import { BASE_URL } from "../../../config/config";
import "./newRequest.css";
import RecordNotFound from "../../../components/RecordNotFound";
import BankDetailsModal from "../../../components/BankDetailsModal";
import Slider from "react-slick";
import cardPic from "../../../assets/card_pic.webp";
import { ValidateUser } from "../../../redux/reducer/ValidateUser";
import SecureImage from "../../../components/SecureImage";
import EventBusyIcon from "@mui/icons-material/EventBusy";
import TimerOffIcon from "@mui/icons-material/TimerOff";

// "khosa center • Flat #12 • Floor 2" — the property name alone is ambiguous
// when one property has several flats, so every place that names a request's
// property should go through this.
const flatLabel = (request) => {
  const num = request?.flatDetail?.flatNumber;
  const floor = request?.flatDetail?.flatFloor;
  return [
    request?.flatName || "Flat",
    num ? `Flat #${num}` : null,
    floor !== undefined && floor !== null && floor !== "" ? `Floor ${floor}` : null,
  ]
    .filter(Boolean)
    .join(" • ");
};

// The interest form stores DD-MM-YYYY. Returns false on anything unreadable so
// a bad value can never open the confirm button by accident — an owner cannot
// certify that someone moved in on a day that has not happened yet.
const isMoveInDue = (moveInDate) => {
  if (!moveInDate) return false;

  const match = String(moveInDate).match(/^(\d{2})-(\d{2})-(\d{4})$/);
  const date = match
    ? new Date(Number(match[3]), Number(match[2]) - 1, Number(match[1]))
    : new Date(moveInDate);

  if (Number.isNaN(date.getTime())) return false;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  date.setHours(0, 0, 0, 0);
  return date <= today;
};

export default function NewRequest() {
  const open = useSelector((state) => state.sidebar.open);
  title("Tenant New Request");

  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [mylocation] = useState(location.pathname);
  const [, setAccountDetail] = useState(null);
  const { validateUser } = useSelector((state) => state);
  const dispatch = useDispatch();

  // Interest Requests State
  const [interestRequests, setInterestRequests] = useState([]);
  const [paymentVerificationRequests, setPaymentVerificationRequests] =
    useState([]);
  const [paymentRejectedRequests, setPaymentRejectedRequests] = useState([]);
  const [paymentAcceptedRequests, setPaymentAcceptedRequests] = useState([]);
  const [expiredAcceptedRequests, setExpiredAcceptedRequests] = useState([]);
  const [holdRequests, setHoldRequests] = useState([]);
  const [moveInRequests, setMoveInRequests] = useState([]);
  const [confirmingId, setConfirmingId] = useState(null);
  const [interestLoading, setInterestLoading] = useState(false);
  const [tabLoading, setTabLoading] = useState(false);
  const [actionDialog, setActionDialog] = useState({
    open: false,
    request: null,
    action: "",
  });
  const [responseMessage, setResponseMessage] = useState("");
  const [dueDate, setDueDate] = useState(dayjs());
  const [actionLoading, setActionLoading] = useState(false);
  const [receiptDialog, setReceiptDialog] = useState({
    open: false,
    request: null,
  });
  const [tenantDetailDialog, setTenantDetailDialog] = useState({
    open: false,
    tenant: null,
  });

  // Search and Tab functionality - Initialize from URL params
  const initialTab = parseInt(searchParams.get("tab")) || 0;
  const initialSearch = searchParams.get("search") || "";
  const [activeTab, setActiveTab] = useState(initialTab);
  const [searchQuery, setSearchQuery] = useState(initialSearch);

  // Update URL params when search query or tab changes
  useEffect(() => {
    const params = {};
    if (activeTab !== 0) {
      params.tab = activeTab.toString();
    }
    if (searchQuery.trim()) {
      params.search = searchQuery.trim();
    }
    setSearchParams(params, { replace: true });
  }, [searchQuery, activeTab, setSearchParams]);

  // Bank details modal state
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [pendingAcceptRequest, setPendingAcceptRequest] = useState(null);
  const [checkingBankDetails, setCheckingBankDetails] = useState(false);

  // Calculate statistics
  const totalRequests =
    interestRequests.length +
    paymentVerificationRequests.length +
    paymentRejectedRequests.length +
    paymentAcceptedRequests.length +
    expiredAcceptedRequests.length +
    holdRequests.length +
    moveInRequests.length;

  // Tenants sitting in a flat with bills, maintenance and rent still locked,
  // waiting on one click from the owner.
  const needsMoveInConfirmation = moveInRequests.filter(
    (r) => r.tenantMarkedMoveInAt
  ).length;

  const acceptanceRate =
    totalRequests > 0
      ? ((paymentAcceptedRequests.length / totalRequests) * 100).toFixed(1)
      : 0;

  // ---------------- Fetch Requests ----------------
  useEffect(() => {
    dispatch(GetTenant({ userId: localStorage.getItem("user_id") }));
  }, [dispatch, validateUser]);

  const downloadReceipt = async (url, request) => {
    if (request?.paymentDetail?.paymentMethod === "alfa") {
      const paymentId = request?.paymentDetail?._id;

      // The receipt endpoint now requires login (it returns the tenant's email
      // and the owner's phone number). A plain <a href> can't send a header,
      // so we fetch it as a blob via axios instead.
      try {
        const token =
          localStorage.getItem("token") || sessionStorage.getItem("ots_token");

        const res = await axios.get(
          `${BASE_URL}/api/payment/download-receipt/${paymentId}`,
          {
            responseType: "blob",
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const blobUrl = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = blobUrl;
        link.setAttribute("download", `receipt-${paymentId}.pdf`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      } catch (err) {
        Swal.fire("Failed to download receipt", "", "error");
      }

      return;
    }

    console.log("Downloading receipt from URL:", url);
    console.log("Request details:", request);

    if (!url) return;
    const downloadUrl = url.replace("/upload/", "/upload/fl_attachment/");
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute("download", "cash-receipt");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ---------------- Fetch Account Details ----------------
  useEffect(() => {
    dispatch(GetAccount({ userId: localStorage.getItem("user_id") })).then(
      (res) => {
        setAccountDetail(res?.payload?.data?.data || null);
      }
    );
  }, [dispatch]);

  // ---------------- Fetch Interest Requests ----------------
  // `silent` skips the loading flag for the window-focus auto-refresh below —
  // a tenant can change something (e.g. family size) while the owner just
  // has this tab sitting open, and this page previously only ever fetched
  // once on mount with no way to notice that later, short of a manual
  // reload. A silent background refetch keeps it current without a
  // loading-skeleton flash every time the owner tabs back in.
  const fetchInterestRequests = useCallback((silent = false) => {
    const landlordId =
      localStorage.getItem("user_id") || sessionStorage.getItem("user_id");

    if (landlordId) {
      if (!silent) setInterestLoading(true);
      dispatch(GetLandlordInterestRequests({ landlordId }))
        .then((res) => {
          const responseData =
            res?.payload?.data?.data || res?.payload?.data || [];
          const requests = Array.isArray(responseData) ? responseData : [];

          const pending = requests.filter((r) => r.status === "pending");
          setInterestRequests(pending);

          setPaymentVerificationRequests(
            requests.filter(
              (r) =>
                r.status === "payment_pending" ||
                r.paymentStatus === "verifying"
            )
          );
          setPaymentRejectedRequests(
            requests.filter((r) => r.status === "rejected")
          );
          // Verifying a payment flips the request to "completed", which matched
          // none of these buckets — so a paid booking disappeared from this
          // page the moment the owner verified it. It lands in Move-ins while
          // the tenant is still to arrive, and here once they have.
          setPaymentAcceptedRequests(
            requests.filter(
              (r) =>
                (r.status === "accepted" || r.status === "completed") &&
                r.paymentStatus !== "verifying" &&
                r.moveInStatus !== "awaiting"
            )
          );

          // Paid and booked, waiting on the owner to confirm the tenant is in.
          // Ones where the tenant has already said so come first — those are
          // the bookings actually blocking someone.
          setMoveInRequests(
            requests
              .filter((r) => r.moveInStatus === "awaiting")
              .sort(
                (a, b) =>
                  Boolean(b.tenantMarkedMoveInAt) -
                  Boolean(a.tenantMarkedMoveInAt)
              )
          );
          setExpiredAcceptedRequests(
            requests.filter(
              (r) => r.status === "expired" && r.paymentStatus === "unpaid"
            )
          );
          setHoldRequests(requests.filter((r) => r.status === "hold"));
          if (!silent) setInterestLoading(false);
        })
        .catch(() => {
          if (!silent) setInterestLoading(false);
        });
    }
  }, [dispatch]);

  useEffect(() => {
    fetchInterestRequests();
  }, [dispatch, fetchInterestRequests]);

  // Auto-refresh when the owner tabs back into this page — same pattern as
  // the tenant's My Requests page, so a change made elsewhere (e.g. the
  // tenant editing their profile) shows up without a manual reload.
  useEffect(() => {
    const handleFocus = () => fetchInterestRequests(true);
    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
    // Only set up once on mount, same reasoning as MyRequests.jsx.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---------------- Confirm Move-in ----------------
  const handleConfirmMoveIn = async (request) => {
    const requestId = request._id || request.id;
    setConfirmingId(requestId);

    const res = await dispatch(
      ConfirmMoveIn({
        requestId,
        landlordId:
          localStorage.getItem("user_id") || localStorage.getItem("userId"),
      })
    );
    setConfirmingId(null);

    if (res?.payload?.success) {
      Swal.fire(
        "Move-in confirmed",
        `${request.tenantName} is now an active tenant of ${flatLabel(request)}. Bills, maintenance and rent payment are unlocked for them.`,
        "success"
      );
      fetchInterestRequests();
    } else {
      Swal.fire(
        "Could not confirm move-in",
        typeof res?.payload?.message === "string"
          ? res.payload.message
          : "Please try again in a moment.",
        "error"
      );
    }
  };

  // ---------------- Check Bank Details Before Accept ----------------
  const handleAcceptClick = async (request) => {
    setCheckingBankDetails(true);
    try {
      // AccountDetail.js flips this on Create_User once the owner has saved
      // bank details — this was previously wrapped in a try/catch around
      // code that can't throw, so the modal below never actually opened and
      // an owner could accept a tenant with nowhere for the advance to land.
      const hasBankDetails = Boolean(
        validateUser?.UserValidate?.data?.user?.is_bank
      );
      if (!hasBankDetails) {
        setPendingAcceptRequest(request);
        setBankModalOpen(true);
        return;
      }
      handleOpenActionDialog(request, "accepted");
    } finally {
      setCheckingBankDetails(false);
    }
  };

  const handleBankDetailsSuccess = () => {
    setBankModalOpen(false);
    if (pendingAcceptRequest) {
      handleOpenActionDialog(pendingAcceptRequest, "accepted");
      setPendingAcceptRequest(null);
    }
  };

  // ---------------- Interest Request Actions ----------------
  const handleOpenActionDialog = (request, action) => {
    console.log(
      "Opening action dialog for request:",
      request,
      "with action:",
      action
    );
    setActionDialog({ open: true, request, action });
    setResponseMessage("");
    setDueDate(dayjs());
    if (request?.status === "expired" && action === "accepted") {
      setDueDate(dayjs().add(2, "day"));
    }
  };

  const handleCloseActionDialog = () => {
    setActionDialog({ open: false, request: null, action: "" });
    setResponseMessage("");
    setDueDate(dayjs());
  };

  const handleConfirmInterestAction = async () => {
    const { request, action } = actionDialog;
    if (!request) return;

    if (action === "accepted") {
      if (!dueDate) {
        Swal.fire("Due Date is required", "", "error");
        return;
      }
      if (dueDate.isBefore(dayjs().startOf("day"))) {
        Swal.fire("Due Date cannot be in the past", "", "error");
        return;
      }
    }

    setActionLoading(true);

    try {
      const result = await dispatch(
        UpdateInterestRequestStatus({
          requestId: request._id || request.id,
          status: action,
          message: responseMessage,
          due_date: dueDate.format("YYYY-MM-DD"),
        })
      );

      if (result?.payload?.data?.success || result?.payload?.status === 200) {
        Swal.fire(
          action === "accepted"
            ? "Accepted! Tenant will be notified to make payment."
            : "Rejected!",
          flatLabel(request),
          "success"
        );
        handleCloseActionDialog();
        fetchInterestRequests();
      } else {
        Swal.fire(
          result?.payload?.data?.message || "Failed to update",
          "",
          "error"
        );
      }
    } catch (err) {
      Swal.fire("Something went wrong", "", "error");
    } finally {
      setActionLoading(false);
    }
  };

  // ---------------- Payment Verification Actions ----------------
  const handleOpenReceiptDialog = (request) => {
    setReceiptDialog({ open: true, request });
  };

  const handleCloseReceiptDialog = () => {
    setReceiptDialog({ open: false, request: null });
  };

  // ---------------- Tenant Detail Dialog ----------------
  const handleOpenTenantDetailDialog = (tenant) => {
    setTenantDetailDialog({ open: true, tenant });
  };

  const handleCloseTenantDetailDialog = () => {
    setTenantDetailDialog({ open: false, tenant: null });
  };

  const handleVerifyPayment = async (request, isApproved) => {
    setActionLoading(true);
    try {
      const landlordId = localStorage.getItem("user_id");

      if (request.paymentId) {
        const token =
          localStorage.getItem("token") || sessionStorage.getItem("ots_token");

        const response = await axios.post(
          `${BASE_URL}/safepay/confirm-payment/${request.paymentId}`,
          {
            // landlordId is now taken from the server token — the id in the
            // request body is not trusted.
            action: isApproved ? "verify" : "reject",
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response?.data?.success) {
          Swal.fire(
            isApproved ? "Payment Verified!" : "Payment Rejected!",
            `${flatLabel(request)} — ${
              isApproved ? "Tenant is now confirmed." : "Tenant will be notified."
            }`,
            isApproved ? "success" : "warning"
          );
          handleCloseReceiptDialog();
          fetchInterestRequests();
          dispatch(ValidateUser({}));
        } else {
          Swal.fire(response?.data?.message || "Failed to update", "", "error");
        }
      } else {
        const result = await dispatch(
          UpdateInterestRequestStatus({
            requestId: request._id || request.id,
            status: isApproved ? "completed" : "rejected",
            message: isApproved
              ? "Payment verified successfully"
              : "Payment rejected",
            paymentStatus: isApproved ? "verified" : "failed",
          })
        );

        if (result?.payload?.data?.success || result?.payload?.status === 200) {
          Swal.fire(
            isApproved ? "Payment Verified!" : "Payment Rejected!",
            `${flatLabel(request)} — ${
              isApproved ? "Tenant is now confirmed." : "Tenant will be notified."
            }`,
            isApproved ? "success" : "warning"
          );
          handleCloseReceiptDialog();
          fetchInterestRequests();
        } else {
          Swal.fire(
            result?.payload?.data?.message || "Failed to update",
            "",
            "error"
          );
        }
      }
    } catch (err) {
      Swal.fire("Something went wrong", "", "error");
    } finally {
      setActionLoading(false);
    }
  };

  const CustomArrow = ({ onClick, direction }) => (
    <div
      className={`custom-arrow ${direction}`}
      onClick={onClick}
      role="button"
    />
  );

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 4000,
    nextArrow: <CustomArrow direction="next" />,
    prevArrow: <CustomArrow direction="prev" />,
  };

  // Handle tab change with loading state
  const handleTabChange = async (event, newValue) => {
    setTabLoading(true);
    setActiveTab(newValue);

    // Refresh data when tab changes
    await fetchInterestRequests();

    // Simulate loading for smooth transition
    setTimeout(() => {
      setTabLoading(false);
    }, 300);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchQuery("");
  };

  // Filter function for search
  const filterRequests = (requests) => {
    if (!searchQuery.trim()) return requests;

    const query = searchQuery.toLowerCase();
    return requests.filter(
      (request) =>
        request.tenantName?.toLowerCase().includes(query) ||
        request.tenantEmail?.toLowerCase().includes(query) ||
        request.tenantPhone?.toLowerCase().includes(query) ||
        request.flatName?.toLowerCase().includes(query) ||
        String(request.flatDetail?.flatNumber ?? "").toLowerCase().includes(query) ||
        request.occupation?.toLowerCase().includes(query)
    );
  };

  // Get filtered data based on active tab
  // Tab order follows the booking's own journey: request comes in, payment is
  // verified, tenant moves in. Move-ins sits at index 2 because that is where
  // it happens, not appended at the end where nobody looks.
  const getFilteredData = () => {
    switch (activeTab) {
      case 0:
        return filterRequests(interestRequests);
      case 1:
        return filterRequests(paymentVerificationRequests);
      case 2:
        return filterRequests(moveInRequests);
      case 3:
        return filterRequests(paymentRejectedRequests);
      case 4:
        return filterRequests(paymentAcceptedRequests);
      case 5:
        return filterRequests(holdRequests);
      case 6:
        return filterRequests(expiredAcceptedRequests);
      default:
        return [];
    }
  };
  console.log(expiredAcceptedRequests, "expiredAcceptedRequests");

  // Skeleton Card Component
  const SkeletonCard = () => (
    <Grid item xs={12} md={6} lg={4}>
      <Card elevation={3} sx={{ borderRadius: 3, overflow: "hidden" }}>
        <Box sx={{ width: "100%", height: 220, bgcolor: "grey.200" }} />
        <CardContent sx={{ p: 2.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
            <Box
              sx={{
                width: 44,
                height: 44,
                borderRadius: "50%",
                bgcolor: "grey.300",
              }}
            />
            <Box sx={{ flexGrow: 1 }}>
              <Box
                sx={{
                  width: "60%",
                  height: 20,
                  bgcolor: "grey.300",
                  borderRadius: 1,
                  mb: 1,
                }}
              />
              <Box
                sx={{
                  width: "40%",
                  height: 14,
                  bgcolor: "grey.200",
                  borderRadius: 1,
                }}
              />
            </Box>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Box
            sx={{
              width: "100%",
              height: 40,
              bgcolor: "grey.200",
              borderRadius: 2,
              mb: 2,
            }}
          />
          <Stack spacing={1.5} sx={{ mb: 2 }}>
            <Box
              sx={{
                width: "80%",
                height: 16,
                bgcolor: "grey.200",
                borderRadius: 1,
              }}
            />
            <Box
              sx={{
                width: "70%",
                height: 16,
                bgcolor: "grey.200",
                borderRadius: 1,
              }}
            />
            <Box
              sx={{
                width: "60%",
                height: 16,
                bgcolor: "grey.200",
                borderRadius: 1,
              }}
            />
          </Stack>
          <Box sx={{ display: "flex", gap: 1.5 }}>
            <Box
              sx={{ flex: 1, height: 40, bgcolor: "grey.300", borderRadius: 2 }}
            />
            <Box
              sx={{ flex: 1, height: 40, bgcolor: "grey.300", borderRadius: 2 }}
            />
          </Box>
        </CardContent>
      </Card>
    </Grid>
  );

  // ===========================================================
  // --------- Universal Request Card Component ----------------
  // ===========================================================
  const renderRequestCard = (request, tabType) => {
    // Define status configurations for each tab
    const statusConfig = {
      pending: {
        color: "#ff9800",
        gradient: "linear-gradient(90deg, #ff9800 0%, #f57c00 100%)",
        // A request you already accepted can land back here if the tenant
        // changed something material (e.g. family size) before paying —
        // reReviewReason says why, so it doesn't read as a brand-new,
        // never-looked-at request.
        chipLabel: request.reReviewReason ? "Needs Re-Review" : "Pending Review",
        chipColor: request.reReviewReason ? "error" : "warning",
        chipIcon: <HourglassEmptyIcon />,
        showAcceptReject: true,
        showVerifyReject: false,
        showReceipt: false,
        showAlert: Boolean(request.reReviewReason),
        alertMessage: request.reReviewReason,
        showRevokeButton: false,
      },
      paymentVerification: {
        color: "var(--owner-primary)",
        gradient: "linear-gradient(90deg, var(--owner-primary) 0%, var(--owner-primary-hover) 100%)",
        chipLabel:
          request?.paymentDetail?.paymentMethod === "safepay"
            ? "Online Payment - SafePay"
            : request?.paymentDetail?.paymentMethod === "alfa"
            ? "Online Payment - Alfa"
            : "Cash Receipt",
        chipColor:
          request?.paymentDetail?.paymentMethod === "safepay"
            ? "success"
            : "info",
        chipIcon:
          request.paymentMethod !== "safepay" ? <DownloadIcon /> : undefined,
        chipClickable: request.paymentMethod !== "safepay",
        showAcceptReject: false,
        showVerifyReject: true,
        showReceipt: true,
        showAlert: true,
        alertMessage: "Payment submitted - Awaiting verification",
        showRevokeButton: false,
      },
      rejected: {
        color: "#f44336",
        gradient: "linear-gradient(90deg, #f44336 0%, #d32f2f 100%)",
        chipLabel: "Rejected",
        chipColor: "error",
        chipIcon: <CancelIcon />,
        showAcceptReject: false,
        showVerifyReject: false,
        showReceipt: false,
        showAlert: false,
        showRevokeButton: false,
      },
      accepted: {
        color: "#4caf50",
        gradient: "linear-gradient(90deg, #4caf50 0%, #388e3c 100%)",
        chipLabel: "Accepted",
        chipColor: "success",
        chipIcon: <CheckCircleIcon />,
        showAcceptReject: false,
        showVerifyReject: false,
        showReceipt: false,
        showAlert: false,
        showRevokeButton: true, // IMPORTANT: Show revoke button for accepted requests
      },
      // Paid, booked, waiting for the tenant to actually arrive. The tenant
      // reporting it is stronger evidence than the calendar, so it turns the
      // card amber and opens the button even if they moved in early.
      moveIn: {
        color: request?.tenantMarkedMoveInAt
          ? "#f59e0b"
          : "var(--owner-primary)",
        gradient: request?.tenantMarkedMoveInAt
          ? "linear-gradient(90deg, #f59e0b 0%, #d97706 100%)"
          : "linear-gradient(90deg, var(--owner-primary) 0%, var(--owner-primary-hover) 100%)",
        chipLabel: request?.tenantMarkedMoveInAt
          ? "Needs your confirmation"
          : "Awaiting move-in",
        chipColor: request?.tenantMarkedMoveInAt ? "warning" : "info",
        chipIcon: <HomeIcon />,
        showAcceptReject: false,
        showVerifyReject: false,
        showReceipt: false,
        showAlert: true,
        alertMessage: request?.tenantMarkedMoveInAt
          ? `${request?.tenantName} says they have moved in to ${flatLabel(request)} — confirm to start the tenancy`
          : `Move-in set for ${request?.moveInDate || "an unset date"}`,
        showRevokeButton: false,
        showConfirmMoveIn: true,
      },
      hold: {
        color: "#ff9800",
        gradient: "linear-gradient(90deg, #ff9800 0%, #f57c00 100%)",
        chipLabel: "On Hold",
        chipColor: "warning",
        chipIcon: <PauseCircleIcon />,
        showAcceptReject: false,
        showVerifyReject: false,
        showReceipt: false,
        showAlert: false,
        showRevokeButton: false,
      },
      expired: {
        color: "#9e9e9e",
        gradient: "linear-gradient(90deg, #9e9e9e 0%, #616161 100%)",
        chipLabel: "Expired",
        chipColor: "default",
        chipIcon: <PauseCircleIcon />,
        showAcceptReject: true,
        showVerifyReject: false,
        showReceipt: false,
        showAlert: false,
        showRevokeButton: false,
      },
    };

    const config = statusConfig[tabType];
    console.log(request, tabType);

    // Helper: Bill badge box
    // const billBadge = request.flatDetail?.bill_uploaded_by ? (
    //   <Box
    //     sx={{
    //       position: 'absolute',
    //       top: 12,
    //       left: 12,
    //       display: 'inline-flex',
    //       alignItems: 'center',
    //       gap: 0.5,
    //       px: 1,
    //       py: 0.4,
    //       borderRadius: '6px',
    //       fontSize: '10px',
    //       fontWeight: 700,
    //       backdropFilter: 'blur(4px)',
    //       boxShadow: '0 2px 6px rgba(0,0,0,0.25)',
    //       zIndex: 2,
    //       ...(request.flatDetail?.bill_uploaded_by?.toLowerCase() === 'owner' ||
    //       request.flatDetail?.bill_uploaded_by?.toLowerCase() === 'landlord'
    //         ? { bgcolor: 'rgba(16, 185, 129, 0.85)', color: '#fff' }
    //         : { bgcolor: 'rgba(59, 130, 246, 0.85)', color: '#fff' }),
    //     }}
    //   >
    //     <ReceiptLongIcon sx={{ fontSize: 12 }} />
    //     <span>
    //       Bill:{' '}
    //       {request.flatDetail?.bill_uploaded_by?.toLowerCase() === 'owner' ||
    //       request.flatDetail?.bill_uploaded_by?.toLowerCase() === 'landlord'
    //         ? 'Owner'
    //         : 'Tenant'}
    //     </span>
    //   </Box>
    // ) : null;

    return (
      <Grid item xs={12} md={6} lg={4} key={request._id || request.id}>
        <Zoom in={true}>
          <Card
            elevation={3}
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              transition: "all 0.3s ease-in-out",
              "&:hover": {
                transform: "translateY(-8px)",
                boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
              },
              borderRadius: 3,
              overflow: "hidden",
              position: "relative",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "4px",
                background: config.gradient,
              },
            }}
          >
            {/* Image Slider Section */}
            {request?.flatDetail?.images?.length > 0 ? (
              <Box className="flat-slider" sx={{ position: "relative" }}>
                <Slider {...sliderSettings}>
                  {request.flatDetail.images.map((img, i) => (
                    <Box
                      key={i}
                      component="img"
                      src={img}
                      alt={`Flat ${request.flatName} ${i}`}
                      sx={{
                        width: "100%",
                        height: 220,
                        objectFit: "cover",
                      }}
                    />
                  ))}
                </Slider>
                <Chip
                  icon={config.chipIcon}
                  label={config.chipLabel}
                  color={config.chipColor}
                  size="small"
                  clickable={config.chipClickable}
                  onClick={() => {
                    if (config.chipClickable) {
                      downloadReceipt(request.paymentDetail?.receipt, request);
                    }
                  }}
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    fontWeight: 600,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                />
                {/* Bill Uploaded By Badge */}
                {/* {billBadge} */}
              </Box>
            ) : (
              <Box sx={{ position: "relative" }}>
                <Box
                  component="img"
                  src={cardPic}
                  alt="No flat image"
                  sx={{
                    width: "100%",
                    height: 220,
                    objectFit: "cover",
                    filter: "brightness(0.9)",
                  }}
                />
                <Chip
                  icon={config.chipIcon}
                  label={config.chipLabel}
                  color={config.chipColor}
                  size="small"
                  clickable={config.chipClickable}
                  onClick={() => {
                    if (config.chipClickable) {
                      downloadReceipt(request.paymentDetail?.receipt);
                    }
                  }}
                  sx={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    fontWeight: 600,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                />
                {/* Bill Uploaded By Badge */}
                {/* {billBadge} */}
              </Box>
            )}

            <CardContent sx={{ flexGrow: 1, p: 2.5 }}>
              {/* Tenant Profile Header */}
              <Box sx={{ mb: 2 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    mb: 1.5,
                  }}
                >
                  <Avatar
                    src={
                      request.tenantDetail?.profilePhoto ||
                      request.tenantProfile ||
                      request.tenantImage
                    }
                    sx={{
                      bgcolor: config.color,
                      width: 56,
                      height: 56,
                      border: "3px solid #fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                    }}
                  >
                    {!request.tenantDetail?.profilePhoto &&
                      !request.tenantProfile &&
                      !request.tenantImage && <PersonIcon />}
                  </Avatar>
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography
                      variant="h6"
                      fontWeight={700}
                      sx={{ lineHeight: 1.2, mb: 0.5 }}
                    >
                      {request.tenantName || "Unknown Tenant"}
                    </Typography>
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <CalendarMonthIcon sx={{ fontSize: 14 }} />
                      {moment(request.createdAt || request.created_at).format(
                        "DD MMM YYYY, hh:mm A"
                      )}
                    </Typography>
                  </Box>
                </Box>

                {/* Alert for Payment Verification */}
                {config.showAlert && (
                  <Alert
                    severity="info"
                    icon={<PendingActionsIcon />}
                    sx={{ py: 0.5 }}
                  >
                    <Typography variant="caption" fontWeight={600}>
                      {config.alertMessage}
                    </Typography>
                  </Alert>
                )}
              </Box>

              <Divider sx={{ my: 2 }} />

              {/* Flat Info */}
              <Paper
                elevation={0}
                sx={{
                  bgcolor: `${config.color}15`,
                  p: 1.5,
                  borderRadius: 2,
                  mb: 2,
                  border: `1px solid ${config.color}30`,
                }}
              >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <HomeIcon sx={{ color: config.color }} fontSize="small" />
                  <Typography
                    variant="subtitle2"
                    fontWeight={700}
                    sx={{ color: config.color }}
                  >
                    {flatLabel(request)}
                  </Typography>
                </Box>
              </Paper>

              {/* Payment Details (Full details for Payment Verification Tab) */}
              {config.showReceipt && (
                <Paper
                  elevation={0}
                  sx={{
                    bgcolor: "#f5f5f5",
                    p: 2,
                    borderRadius: 2,
                    mb: 2,
                  }}
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={600}
                    sx={{ mb: 1, display: "block" }}
                  >
                    Payment Details
                  </Typography>
                  <Stack spacing={1}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Amount:
                      </Typography>
                      <Typography
                        variant="body2"
                        color="success.main"
                        fontWeight={700}
                      >
                        Rs{" "}
                        {Number(
                          request.paymentDetail?.amount -
                            request?.paymentDetail?.commissionAmount -
                            request?.paymentDetail?.processingAmount || 0
                        ).toLocaleString()}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        OTS Fees:
                      </Typography>
                      <Typography
                        variant="body2"
                        color="success.main"
                        fontWeight={700}
                      >
                        Rs{" "}
                        {Number(request.commissionAmount || 0).toLocaleString()}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Processing:
                      </Typography>
                      <Typography
                        variant="body2"
                        color="success.main"
                        fontWeight={700}
                      >
                        Rs {Number(request.processingAmount || 0).toFixed(0)}
                      </Typography>
                    </Box>
                    <Divider sx={{ my: 0.5 }} />
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Method:
                      </Typography>
                      <Typography variant="body2">
                        {request.paymentMethod === "safepay"
                          ? "SafePay (Online)"
                          : "Cash / Bank"}
                      </Typography>
                    </Box>
                    {request.paymentDate && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" fontWeight={600}>
                          Date:
                        </Typography>
                        <Typography variant="body2">
                          {request.paymentDate}
                        </Typography>
                      </Box>
                    )}
                    {request.transactionId && (
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" fontWeight={600}>
                          Transaction ID:
                        </Typography>
                        <Typography
                          variant="caption"
                          sx={{
                            fontFamily: "monospace",
                            bgcolor: "white",
                            px: 1,
                            py: 0.5,
                            borderRadius: 1,
                          }}
                        >
                          {request.transactionId}
                        </Typography>
                      </Box>
                    )}
                  </Stack>
                </Paper>
              )}

              {/* Tenant Details */}
              <Stack spacing={1.5} sx={{ mb: 2 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <EmailIcon
                    fontSize="small"
                    sx={{ color: "text.secondary" }}
                  />
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ wordBreak: "break-word" }}
                  >
                    {request.tenantEmail || "N/A"}
                  </Typography>
                </Box>
                {request.flatRent && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      component="svg"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      sx={{ width: 20, height: 20, fill: "text.secondary" }}
                    >
                      <path d="M12 3l9 8h-3v10h-5v-6H11v6H6V11H3z" />
                    </Box>
                    <Typography variant="body2">
                      <strong>Rent:</strong>
                      {request.flatRent}
                    </Typography>
                  </Box>
                )}
                {request.flatAdvance !== null &&
                  request.flatAdvance !== undefined && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <Box
                        component="svg"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        sx={{ width: 20, height: 20, fill: "text.secondary" }}
                      >
                        <path d="M2 7c0-1.1.9-2 2-2h16a2 2 0 012 2v10a2 2 0 01-2 2H4a2 2 0 01-2-2V7zm2 0v10h16V7H4zm11 5a2 2 0 100 4 2 2 0 000-4z" />
                      </Box>
                      <Typography variant="body2">
                        <strong>Advance:</strong> {request.flatAdvance}
                      </Typography>
                    </Box>
                  )}
                {request.tenantPhone && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      component="svg"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      sx={{ width: 20, height: 20, fill: "text.secondary" }}
                    >
                      <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                    </Box>
                    <Typography variant="body2">
                      <strong>Phone:</strong> 03{request.tenantPhone}
                    </Typography>
                  </Box>
                )}

                {/* For Accepted tab, show Due Date and Move-in Date */}
                {tabType === "accepted" && (
                  <>
                    {request.dueDate && (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <CalendarMonthIcon
                          fontSize="small"
                          sx={{ color: "text.secondary" }}
                        />
                        <Typography variant="body2">
                          <strong>Payment Due:</strong> {request.dueDate}
                        </Typography>
                      </Box>
                    )}
                    {request.moveInDate && (
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <CalendarMonthIcon
                          fontSize="small"
                          sx={{ color: "text.secondary" }}
                        />
                        <Typography variant="body2">
                          <strong>Move-in:</strong> {request.moveInDate}
                        </Typography>
                      </Box>
                    )}
                  </>
                )}

                {/* For other tabs, show Move-in Date */}
                {tabType !== "accepted" && request.moveInDate && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <CalendarMonthIcon
                      fontSize="small"
                      sx={{ color: "text.secondary" }}
                    />
                    <Typography variant="body2">
                      <strong>Move-in:</strong> {request.moveInDate}
                    </Typography>
                  </Box>
                )}

                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <GroupIcon
                    fontSize="small"
                    sx={{ color: "text.secondary" }}
                  />
                  <Typography variant="body2">
                    <strong>Family Size:</strong>{" "}
                    {/* tenantDetail is the tenant's CURRENT profile (joined
                        live on every fetch) — request.familySize is only a
                        snapshot from whenever the request was sent, so it
                        can drift the moment the tenant edits their profile.
                        Preferring the live value here keeps this card in
                        sync with "View Complete Tenant Details" below,
                        which already reads tenantDetail directly. */}
                    {request.tenantDetail?.totalFamilyMembers ||
                      request.familySize ||
                      "N/A"}
                  </Typography>
                </Box>

                {request.occupation && (
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <WorkIcon
                      fontSize="small"
                      sx={{ color: "text.secondary" }}
                    />
                    <Typography
                      variant="body2"
                      sx={{ textTransform: "capitalize" }}
                    >
                      <strong>Occupation:</strong> {request.occupation}
                    </Typography>
                  </Box>
                )}

                {/* Show dates for accepted and hold tabs */}
                {(tabType === "accepted" || tabType === "hold") && (
                  <>
                    <Divider sx={{ my: 0.5 }} />
                    {request.requestDate && (
                      <Typography
                        variant="caption"
                        color={`${config.color}`}
                        fontWeight={600}
                      >
                        Requested: {request.requestDate}
                      </Typography>
                    )}
                    {tabType === "accepted" && request.responseDate && (
                      <Typography
                        variant="caption"
                        color={`${config.color}`}
                        fontWeight={600}
                      >
                        Accepted: {request.responseDate}
                      </Typography>
                    )}
                    {tabType === "hold" && request.updatedAt && (
                      <Typography
                        variant="caption"
                        color={`${config.color}`}
                        fontWeight={600}
                      >
                        Put on hold: {request.updatedAt}
                      </Typography>
                    )}
                  </>
                )}
              </Stack>

              {/* Message */}
              {request.message && (
                <Paper
                  elevation={0}
                  sx={{
                    bgcolor: "#f5f5f5",
                    p: 1.5,
                    borderRadius: 2,
                    mb: 2,
                    borderLeft: `3px solid ${config.color}`,
                  }}
                >
                  <Typography
                    variant="caption"
                    color="text.secondary"
                    fontWeight={600}
                  >
                    Message:
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ mt: 0.5, fontStyle: "italic" }}
                  >
                    "{request.message}"
                  </Typography>
                </Paper>
              )}

              {/* Receipt Image Preview (Only for Payment Verification Tab) */}
              {config.showReceipt && request.receiptImage && (
                <Box sx={{ mb: 2 }}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      fontWeight={600}
                    >
                      Uploaded Receipt:
                    </Typography>
                    <Box sx={{ display: "flex", gap: 0.5 }}>
                      <Tooltip title="View full receipt">
                        <IconButton
                          size="small"
                          onClick={() => handleOpenReceiptDialog(request)}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Download receipt">
                        <IconButton
                          size="small"
                          onClick={() => downloadReceipt(request.receiptImage)}
                        >
                          <DownloadIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  <Box
                    component="img"
                    src={request.receiptImage}
                    alt="Payment Receipt"
                    sx={{
                      width: "100%",
                      maxHeight: 150,
                      objectFit: "cover",
                      borderRadius: 2,
                      cursor: "pointer",
                      border: "2px solid #e0e0e0",
                      transition: "all 0.3s",
                      "&:hover": {
                        border: "2px solid var(--owner-primary)",
                        transform: "scale(1.02)",
                      },
                    }}
                    onClick={() => handleOpenReceiptDialog(request)}
                  />
                </Box>
              )}

              {/* Success Alert for Accepted Requests */}
              {tabType === "accepted" && (
                <Alert severity="success" sx={{ borderRadius: 2, mb: 2 }}>
                  <Typography variant="body2" fontWeight={600}>
                    This tenant has been successfully approved for this flat.
                  </Typography>
                </Alert>
              )}

              {/* Warning Alert for Hold Requests */}
              {tabType === "hold" && (
                <Alert severity="warning" sx={{ borderRadius: 2, mb: 2 }}>
                  <Typography variant="body2" fontWeight={600}>
                    This request is currently on hold and awaiting further
                    action.
                  </Typography>
                </Alert>
              )}

              {/* View Full Details Button */}
              {request.tenantDetail && (
                <Button
                  variant="outlined"
                  color="info"
                  size="small"
                  startIcon={<InfoIcon />}
                  onClick={() =>
                    handleOpenTenantDetailDialog(request.tenantDetail)
                  }
                  fullWidth
                  sx={{
                    mb: 2,
                    py: 1,
                    fontWeight: 600,
                    borderRadius: 2,
                    textTransform: "none",
                    borderWidth: 2,
                    "&:hover": {
                      borderWidth: 2,
                      backgroundColor: "rgba(33, 150, 243, 0.04)",
                    },
                  }}
                >
                  View Complete Tenant Details
                </Button>
              )}

              {/* Action Buttons - Accept/Reject */}
              {config.showAcceptReject && (
                <Box sx={{ display: "flex", gap: 1.5, mt: "auto" }}>
                  <Button
                    variant="contained"
                    color="success"
                    size="medium"
                    startIcon={
                      checkingBankDetails ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : (
                        <CheckCircleIcon />
                      )
                    }
                    onClick={() => handleAcceptClick(request)}
                    disabled={checkingBankDetails}
                    fullWidth
                    sx={{
                      py: 1.2,
                      fontWeight: 600,
                      borderRadius: 2,
                      textTransform: "none",
                      boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
                      "&:hover": {
                        boxShadow: "0 6px 16px rgba(76, 175, 80, 0.4)",
                      },
                    }}
                  >
                    {checkingBankDetails ? "Checking..." : "Accept"}
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    size="medium"
                    startIcon={<CancelIcon />}
                    onClick={() => handleOpenActionDialog(request, "rejected")}
                    disabled={checkingBankDetails}
                    fullWidth
                    sx={{
                      py: 1.2,
                      fontWeight: 600,
                      borderRadius: 2,
                      textTransform: "none",
                      borderWidth: 2,
                      "&:hover": {
                        borderWidth: 2,
                        backgroundColor: "rgba(244, 67, 54, 0.04)",
                      },
                    }}
                  >
                    Reject
                  </Button>
                </Box>
              )}

              {/* Action Buttons - Verify/Reject Payment */}
              {config.showVerifyReject && (
                <Box sx={{ display: "flex", gap: 1.5, mt: "auto" }}>
                  <Button
                    variant="contained"
                    color="success"
                    size="medium"
                    startIcon={
                      actionLoading ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : (
                        <VerifiedIcon />
                      )
                    }
                    onClick={() => handleVerifyPayment(request, true)}
                    fullWidth
                    disabled={actionLoading}
                    sx={{
                      py: 1.2,
                      fontWeight: 600,
                      borderRadius: 2,
                      textTransform: "none",
                      boxShadow: "0 4px 12px rgba(76, 175, 80, 0.3)",
                      "&:hover": {
                        boxShadow: "0 6px 16px rgba(76, 175, 80, 0.4)",
                      },
                    }}
                  >
                    {actionLoading ? "Processing..." : "Verify"}
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    size="medium"
                    startIcon={
                      actionLoading ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : (
                        <CancelIcon />
                      )
                    }
                    onClick={() => handleVerifyPayment(request, false)}
                    fullWidth
                    disabled={actionLoading}
                    sx={{
                      py: 1.2,
                      fontWeight: 600,
                      borderRadius: 2,
                      textTransform: "none",
                      borderWidth: 2,
                      "&:hover": {
                        borderWidth: 2,
                        backgroundColor: "rgba(244, 67, 54, 0.04)",
                      },
                    }}
                  >
                    {actionLoading ? "Processing..." : "Reject"}
                  </Button>
                </Box>
              )}

              {/* Revoke Acceptance Button - IMPORTANT: For Accepted Requests Only */}
              {config.showRevokeButton && (
                <Button
                  variant="outlined"
                  color="error"
                  size="medium"
                  startIcon={<CancelIcon />}
                  onClick={() => handleOpenActionDialog(request, "rejected")}
                  disabled={checkingBankDetails}
                  fullWidth
                  sx={{
                    py: 1.2,
                    fontWeight: 600,
                    borderRadius: 2,
                    textTransform: "none",
                    borderWidth: 2,
                    "&:hover": {
                      borderWidth: 2,
                      backgroundColor: "rgba(244, 67, 54, 0.04)",
                    },
                  }}
                >
                  Revoke Acceptance
                </Button>
              )}

              {/* The one action that starts a tenancy. Verifying the payment
                  only books the flat — bills, maintenance and rent stay locked
                  for the tenant until this is pressed. */}
              {config.showConfirmMoveIn && (
                <>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1.5 }}
                  >
                    {request.tenantMarkedMoveInAt
                      ? "Confirm it to start the tenancy — or contact them first if that is not right."
                      : "You can confirm from the move-in date, or sooner if the tenant tells us they have moved in."}
                  </Typography>

                  {request.otsFee?.required &&
                    request.otsFee.status !== "verified" && (
                      <Typography
                        variant="body2"
                        sx={{ mb: 1.5, color: "#92400e", fontWeight: 600 }}
                      >
                        Waiting for OTS to verify the tenant's service fee. You
                        can confirm the move-in once it is verified.
                      </Typography>
                    )}

                  <Button
                    variant="contained"
                    color={request.tenantMarkedMoveInAt ? "warning" : "primary"}
                    size="medium"
                    startIcon={
                      confirmingId === (request._id || request.id) ? (
                        <CircularProgress size={18} color="inherit" />
                      ) : (
                        <HomeIcon />
                      )
                    }
                    disabled={
                      confirmingId === (request._id || request.id) ||
                      (request.otsFee?.required &&
                        request.otsFee.status !== "verified") ||
                      !(
                        request.tenantMarkedMoveInAt ||
                        isMoveInDue(request.moveInDate)
                      )
                    }
                    onClick={() => handleConfirmMoveIn(request)}
                    fullWidth
                    sx={{
                      py: 1.2,
                      fontWeight: 600,
                      borderRadius: 2,
                      textTransform: "none",
                    }}
                  >
                    {confirmingId === (request._id || request.id)
                      ? "Confirming…"
                      : "Yes, confirm move-in"}
                  </Button>
                </>
              )}
            </CardContent>
          </Card>
        </Zoom>
      </Grid>
    );
  };

  // ===========================================================
  // ---------------------- Statistics Cards -------------------
  // ===========================================================
  const StatCard = ({ title, value, icon, color, total }) => {
    const percentage = total > 0 ? (value / total) * 100 : 0;

    return (
      <Card
        elevation={2}
        sx={{
          p: 2.5,
          borderRadius: 3,
          height: "100%",
          background: `linear-gradient(135deg, ${color}15 0%, ${color}05 100%)`,
          border: `1px solid ${color}30`,
          transition: "all 0.3s ease-in-out",
          "&:hover": {
            transform: "translateY(-4px)",
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            mb: 2,
          }}
        >
          <Box>
            <Typography
              variant="body2"
              color="text.secondary"
              fontWeight={600}
              sx={{ mb: 0.5 }}
            >
              {title}
            </Typography>
            <Typography variant="h3" fontWeight={700} color={color}>
              {value}
            </Typography>
          </Box>
          <Avatar
            sx={{
              bgcolor: color,
              width: 48,
              height: 48,
              boxShadow: `0 4px 12px ${color}40`,
            }}
          >
            {icon}
          </Avatar>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
          >
            <Typography variant="caption" color="text.secondary">
              Progress
            </Typography>
            <Typography variant="caption" fontWeight={600} color={color}>
              {percentage.toFixed(0)}%
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={percentage}
            sx={{
              height: 6,
              borderRadius: 3,
              bgcolor: `${color}20`,
              "& .MuiLinearProgress-bar": {
                bgcolor: color,
                borderRadius: 3,
              },
            }}
          />
        </Box>
      </Card>
    );
  };

  const getNoDataMessage = () => {
    const messages = {
      0: {
        title: "No Pending Requests",
        description: searchQuery
          ? `No pending requests match your search "${searchQuery}"`
          : "You don't have any pending requests at the moment. New tenant requests will appear here.",
      },
      1: {
        title: "No Payments to Verify",
        description: searchQuery
          ? `No payment verification requests match your search "${searchQuery}"`
          : "When tenants submit their payment, they will appear here for verification.",
      },
      2: {
        title: "No Move-ins Waiting",
        description: searchQuery
          ? `No move-ins match your search "${searchQuery}"`
          : "Once a tenant's payment is verified, their booking waits here until you confirm they have moved in.",
      },
      3: {
        title: "No Rejected Requests",
        description: searchQuery
          ? `No rejected requests match your search "${searchQuery}"`
          : "Rejected payment requests will appear here.",
      },
      4: {
        title: "No Accepted Requests",
        description: searchQuery
          ? `No accepted requests match your search "${searchQuery}"`
          : "Once a tenant's request is accepted, it will appear here.",
      },
      5: {
        title: "No Requests on Hold",
        description: searchQuery
          ? `No hold requests match your search "${searchQuery}"`
          : "Requests that are put on hold will appear here.",
      },
      6: {
        title: "No Requests on Expired",
        description: searchQuery
          ? `No expired requests match your search "${searchQuery}"`
          : "Requests that have expired will appear here.",
      },
    };

    return messages[activeTab] || messages[0];
  };

  const noDataInfo = getNoDataMessage();

  // ===========================================================
  // ------------ Tenant Detail Dialog Component ---------------
  // ===========================================================
  const TenantDetailDialog = () => {
    const tenant = tenantDetailDialog.tenant;
    if (!tenant) return null;

    return (
      <Dialog
        open={tenantDetailDialog.open}
        onClose={handleCloseTenantDetailDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            maxHeight: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            pb: 2,
            background: "linear-gradient(135deg, var(--owner-primary) 0%, var(--owner-nav) 100%)",
            color: "white",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Avatar
              src={tenant.profilePhoto}
              sx={{
                width: 64,
                height: 64,
                border: "3px solid white",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              }}
            >
              <PersonIcon sx={{ fontSize: 40 }} />
            </Avatar>
            <Box>
              <Typography variant="h5" fontWeight={700}>
                {tenant.name || "Tenant Details"}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                Complete Profile Information
              </Typography>
            </Box>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pt: 3 }}>
          <Stack spacing={3}>
            {/* Personal Information */}
            <Paper
              elevation={0}
              sx={{ p: 2.5, bgcolor: "#f8f9fa", borderRadius: 2 }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <PersonIcon color="primary" />
                <Typography variant="h6" fontWeight={700}>
                  Personal Information
                </Typography>
              </Box>

              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                        Full Name
                      </TableCell>
                      <TableCell>{tenant.name || "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Father's Name
                      </TableCell>
                      <TableCell>{tenant.fatherName || "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
                      <TableCell>{tenant.email || "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Mobile Number
                      </TableCell>
                      <TableCell>{tenant.mobileNumber || "N/A"}</TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Gender</TableCell>
                      <TableCell sx={{ textTransform: "capitalize" }}>
                        {tenant.gender || "N/A"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Marital Status
                      </TableCell>
                      <TableCell sx={{ textTransform: "capitalize" }}>
                        {tenant.maritalStatus || "N/A"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Cast</TableCell>
                      <TableCell>{tenant.cast || "N/A"}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {/* CNIC Information */}
            <Paper
              elevation={0}
              sx={{ p: 2.5, bgcolor: "#fff8e1", borderRadius: 2 }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <BadgeIcon color="warning" />
                <Typography variant="h6" fontWeight={700}>
                  CNIC Information
                </Typography>
              </Box>

              <Typography variant="body2" fontWeight={600} sx={{ mb: 1 }}>
                CNIC Number: {tenant.cnicNo || "N/A"}
              </Typography>

              <Grid container spacing={2}>
                {tenant.cnicFront && (
                  <Grid item xs={12} sm={6}>
                    <Paper
                      elevation={3}
                      sx={{ p: 1.5, borderRadius: 2, height: 260 }}
                    >
                      <Typography
                        variant="caption"
                        fontWeight={600}
                        color="text.secondary"
                        sx={{ mb: 1 }}
                      >
                        CNIC Front
                      </Typography>
                      <Box sx={{ height: "100%" }}>
                        <SecureImage src={tenant.cnicFront} alt="CNIC Front" />
                      </Box>
                    </Paper>
                  </Grid>
                )}

                {tenant.cnicBack && (
                  <Grid item xs={12} sm={6}>
                    <Paper
                      elevation={3}
                      sx={{ p: 1.5, borderRadius: 2, height: 260 }}
                    >
                      <Typography
                        variant="caption"
                        fontWeight={600}
                        color="text.secondary"
                        sx={{ mb: 1 }}
                      >
                        CNIC Back
                      </Typography>
                      <Box sx={{ height: "100%" }}>
                        <SecureImage src={tenant.cnicBack} alt="CNIC Back" />
                      </Box>
                    </Paper>
                  </Grid>
                )}
              </Grid>
            </Paper>

            {/* Signature */}
            {tenant.signature && (
              <Paper
                elevation={0}
                sx={{ p: 2.5, bgcolor: "#e3f2fd", borderRadius: 2 }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <DescriptionIcon color="info" />
                  <Typography variant="h6" fontWeight={700}>
                    Signature
                  </Typography>
                </Box>

                <Paper
                  elevation={3}
                  sx={{
                    p: 2,
                    borderRadius: 2,
                    bgcolor: "#fafafa",
                    width: "100%",
                    maxWidth: 500,
                    mx: "auto",
                    boxShadow: "0 6px 20px rgba(0,0,0,0.08)",
                  }}
                >
                  <SecureImage
                    src={tenant.signature}
                    alt="Signature"
                    height={160}
                  />
                </Paper>
              </Paper>
            )}

            {/* Address Information */}
            <Paper
              elevation={0}
              sx={{ p: 2.5, bgcolor: "#f3e5f5", borderRadius: 2 }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <HomeIcon color="secondary" />
                <Typography variant="h6" fontWeight={700}>
                  Address Information
                </Typography>
              </Box>

              <Stack spacing={2}>
                <Box>
                  <Typography
                    variant="caption"
                    fontWeight={600}
                    color="text.secondary"
                  >
                    Current Address
                  </Typography>
                  <Typography variant="body2">
                    {tenant.currentAddress || "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography
                    variant="caption"
                    fontWeight={600}
                    color="text.secondary"
                  >
                    Permanent Address
                  </Typography>
                  <Typography variant="body2">
                    {tenant.permanentAddress || "N/A"}
                  </Typography>
                </Box>
              </Stack>
            </Paper>

            {/* Family & Tenant Type */}
            <Paper
              elevation={0}
              sx={{ p: 2.5, bgcolor: "#e8f5e9", borderRadius: 2 }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <FamilyRestroomIcon color="success" />
                <Typography variant="h6" fontWeight={700}>
                  Family Information
                </Typography>
              </Box>

              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                        Tenant Type
                      </TableCell>
                      <TableCell sx={{ textTransform: "capitalize" }}>
                        {tenant.tenantType || "N/A"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Total Family Members
                      </TableCell>
                      <TableCell>
                        {tenant.totalFamilyMembers || "N/A"}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>Languages</TableCell>
                      <TableCell>
                        {tenant.language?.join(", ") || "N/A"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {/* Employment Information */}
            <Paper
              elevation={0}
              sx={{ p: 2.5, bgcolor: "#fff3e0", borderRadius: 2 }}
            >
              <Box
                sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
              >
                <WorkIcon color="warning" />
                <Typography variant="h6" fontWeight={700}>
                  Employment Information
                </Typography>
              </Box>

              <TableContainer>
                <Table size="small">
                  <TableBody>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                        Employment Status
                      </TableCell>
                      <TableCell sx={{ textTransform: "capitalize" }}>
                        {tenant.employmentStatus || "N/A"}
                      </TableCell>
                    </TableRow>
                    {tenant.companyName && (
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Company Name
                        </TableCell>
                        <TableCell>{tenant.companyName}</TableCell>
                      </TableRow>
                    )}
                    {tenant.designation && (
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Designation
                        </TableCell>
                        <TableCell>{tenant.designation}</TableCell>
                      </TableRow>
                    )}
                    {tenant.instituteName && (
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>
                          Institute Name
                        </TableCell>
                        <TableCell>{tenant.instituteName}</TableCell>
                      </TableRow>
                    )}
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Monthly Income
                      </TableCell>
                      <TableCell sx={{ textTransform: "uppercase" }}>
                        {tenant.monthlyIncome?.replace(/_/g, " - ") || "N/A"}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              {tenant.incomeProof && (
                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="caption"
                    fontWeight={600}
                    color="text.secondary"
                    sx={{ mb: 1, display: "block" }}
                  >
                    Income Proof Document
                  </Typography>
                  <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    onClick={() => window.open(tenant.incomeProof, "_blank")}
                    size="small"
                    sx={{ textTransform: "none" }}
                  >
                    View Income Proof
                  </Button>
                </Box>
              )}
            </Paper>

            {/* Pets & Vehicle Information */}
            {(tenant.hasPets || tenant.hasVehicle) && (
              <Paper
                elevation={0}
                sx={{ p: 2.5, bgcolor: "#fce4ec", borderRadius: 2 }}
              >
                <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
                  Additional Information
                </Typography>

                <TableContainer>
                  <Table size="small">
                    <TableBody>
                      {tenant.hasPets && (
                        <>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <PetsIcon fontSize="small" color="error" />
                                Has Pets
                              </Box>
                            </TableCell>
                            <TableCell>Yes</TableCell>
                          </TableRow>
                          {tenant.petType && (
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Pet Type
                              </TableCell>
                              <TableCell sx={{ textTransform: "capitalize" }}>
                                {tenant.petType}
                              </TableCell>
                            </TableRow>
                          )}
                          {tenant.petCount && (
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Number of Pets
                              </TableCell>
                              <TableCell>{tenant.petCount}</TableCell>
                            </TableRow>
                          )}
                        </>
                      )}
                      {tenant.hasVehicle && (
                        <>
                          <TableRow>
                            <TableCell sx={{ fontWeight: 600 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1,
                                }}
                              >
                                <DirectionsCarIcon
                                  fontSize="small"
                                  color="error"
                                />
                                Has Vehicle
                              </Box>
                            </TableCell>
                            <TableCell>Yes</TableCell>
                          </TableRow>
                          {tenant.vehicleType && (
                            <TableRow>
                              <TableCell sx={{ fontWeight: 600 }}>
                                Vehicle Type
                              </TableCell>
                              <TableCell sx={{ textTransform: "capitalize" }}>
                                {tenant.vehicleType}
                              </TableCell>
                            </TableRow>
                          )}
                        </>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}

            {/* Emergency Contact */}
            {tenant.emergencyContactName && (
              <Paper
                elevation={0}
                sx={{ p: 2.5, bgcolor: "#ffebee", borderRadius: 2 }}
              >
                <Box
                  sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}
                >
                  <ContactPhoneIcon color="error" />
                  <Typography variant="h6" fontWeight={700}>
                    Emergency Contact
                  </Typography>
                </Box>

                <TableContainer>
                  <Table size="small">
                    <TableBody>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                          Name
                        </TableCell>
                        <TableCell>{tenant.emergencyContactName}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Relation</TableCell>
                        <TableCell sx={{ textTransform: "capitalize" }}>
                          {tenant.emergencyContactRelation || "N/A"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600 }}>Phone</TableCell>
                        <TableCell>
                          {tenant.emergencyContactPhone || "N/A"}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}

            {/* Previous Rental History */}
            {tenant.hasPreviousRental && (
              <Paper
                elevation={0}
                sx={{ p: 2.5, bgcolor: "#f1f8e9", borderRadius: 2 }}
              >
                <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
                  Previous Rental History
                </Typography>

                <TableContainer>
                  <Table size="small">
                    <TableBody>
                      {tenant.previousLandlordName && (
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600, width: "40%" }}>
                            Previous Landlord
                          </TableCell>
                          <TableCell>{tenant.previousLandlordName}</TableCell>
                        </TableRow>
                      )}
                      {tenant.previousLandlordPhone && (
                        <TableRow>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Landlord Phone
                          </TableCell>
                          <TableCell>{tenant.previousLandlordPhone}</TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Paper>
            )}

            {/* About Me */}
            {tenant.aboutMe && (
              <Paper
                elevation={0}
                sx={{ p: 2.5, bgcolor: "#f5f5f5", borderRadius: 2 }}
              >
                <Typography variant="h6" fontWeight={700} sx={{ mb: 2 }}>
                  About Tenant
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ lineHeight: 1.8, fontStyle: "italic" }}
                >
                  "{tenant.aboutMe}"
                </Typography>
              </Paper>
            )}
          </Stack>
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 2.5, bgcolor: "#f8f9fa" }}>
          <Button
            onClick={handleCloseTenantDetailDialog}
            variant="contained"
            sx={{
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              px: 4,
              py: 1,
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  // ===========================================================
  // ------------------------- MAIN UI -------------------------
  // ===========================================================
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Wrapper open={open} mylocation={mylocation} />

      <div className={`${open ? "sidebar-open" : "sidebar-closed"}`}>
        <Container maxWidth="xl" sx={{ py: 4 }}>
          {/* Header Section */}
          <Fade in={true} timeout={800}>
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h4"
                fontWeight={700}
                sx={{
                  mb: 1,
                  background:
                    "linear-gradient(135deg, var(--owner-primary) 0%, var(--owner-nav) 100%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                }}
              >
                Tenant Requests Dashboard
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Manage and track all tenant requests in one place
              </Typography>
            </Box>
          </Fade>

          {/* Statistics Cards */}
          <Fade in={!interestLoading} timeout={1000}>
            <Grid container spacing={3} sx={{ mb: 4 }}>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  title="Pending Review"
                  value={interestRequests.length}
                  icon={<HourglassEmptyIcon />}
                  color="#ff9800"
                  total={totalRequests}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  title="Payment Verification"
                  value={paymentVerificationRequests.length}
                  icon={<PendingActionsIcon />}
                  color="var(--owner-primary)"
                  total={totalRequests}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  title="Accepted"
                  value={paymentAcceptedRequests.length}
                  icon={<CheckCircleIcon />}
                  color="#4caf50"
                  total={totalRequests}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={3}>
                <StatCard
                  title="Acceptance Rate"
                  value={`${acceptanceRate}%`}
                  icon={<TrendingUpIcon />}
                  color="#9c27b0"
                  total={100}
                />
              </Grid>
            </Grid>
          </Fade>

          {/* Search Bar */}
          <Paper
            elevation={0}
            sx={{
              mb: 2,
              p: 2,
              borderRadius: 2,
              bgcolor: "white",
              border: "1px solid #e5e7eb",
            }}
          >
            <TextField
              fullWidth
              placeholder="Search by tenant name, email, phone, flat name, or occupation..."
              value={searchQuery}
              onChange={handleSearchChange}
              disabled={interestLoading || tabLoading}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: "#64748b" }} />
                  </InputAdornment>
                ),
                endAdornment: searchQuery && (
                  <InputAdornment position="end">
                    <Button
                      size="small"
                      onClick={handleClearSearch}
                      disabled={interestLoading || tabLoading}
                      sx={{
                        minWidth: "auto",
                        p: 0.5,
                        color: "#64748b",
                        "&:hover": {
                          bgcolor: "#f1f5f9",
                        },
                      }}
                    >
                      <ClearIcon fontSize="small" />
                    </Button>
                  </InputAdornment>
                ),
              }}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                  bgcolor: "#f8fafc",
                  "& fieldset": {
                    borderColor: "transparent",
                  },
                  "&:hover fieldset": {
                    borderColor: "var(--owner-primary)",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--owner-primary)",
                  },
                },
              }}
            />
            {searchQuery && !interestLoading && !tabLoading && (
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ mt: 1, display: "block" }}
              >
                Showing {getFilteredData().length} result
                {getFilteredData().length !== 1 ? "s" : ""} for "{searchQuery}"
              </Typography>
            )}
          </Paper>

          {/* Tabs Section */}
          <Paper
            elevation={0}
            sx={{
              borderRadius: 2,
              overflow: "hidden",
              mb: 3,
              border: "1px solid #e5e7eb",
            }}
          >
            <Tabs
              value={activeTab}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                bgcolor: "background.paper",
                "& .MuiTab-root": {
                  minHeight: 64,
                  minWidth: 160,
                  textTransform: "none",
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  transition: "all 0.3s",
                  px: 3,
                  color: "#64748b",
                  "&:hover": {
                    bgcolor: "action.hover",
                  },
                  "&.Mui-selected": {
                    color: "var(--owner-primary)",
                  },
                  "&.Mui-disabled": {
                    opacity: 0.6,
                  },
                },
                "& .MuiTabs-indicator": {
                  height: 3,
                  borderRadius: "3px 3px 0 0",
                  backgroundColor: "var(--owner-primary)",
                },
              }}
            >
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1,
                    }}
                  >
                    <HourglassEmptyIcon />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        py: 1,
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Pending Review
                      </Typography>
                      <Badge
                        badgeContent={interestRequests.length}
                        color="warning"
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "static",
                            transform: "none",
                            mt: 0.5,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                }
                disabled={interestLoading || tabLoading}
              />
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1,
                    }}
                  >
                    <PendingActionsIcon />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        py: 1,
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Payment Verification
                      </Typography>
                      <Badge
                        badgeContent={paymentVerificationRequests.length}
                        color="info"
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "static",
                            transform: "none",
                            mt: 0.5,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                }
                disabled={interestLoading || tabLoading}
              />
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1,
                    }}
                  >
                    <HomeIcon />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        py: 1,
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Move-ins
                      </Typography>
                      <Badge
                        badgeContent={moveInRequests.length}
                        color={needsMoveInConfirmation > 0 ? "warning" : "info"}
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "static",
                            transform: "none",
                            mt: 0.5,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                }
                disabled={interestLoading || tabLoading}
              />
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1,
                    }}
                  >
                    <CancelIcon />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        py: 1,
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Rejected
                      </Typography>
                      <Badge
                        badgeContent={paymentRejectedRequests.length}
                        color="error"
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "static",
                            transform: "none",
                            mt: 0.5,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                }
                disabled={interestLoading || tabLoading}
              />
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1,
                    }}
                  >
                    <CheckCircleIcon />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        py: 1,
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Accepted
                      </Typography>
                      <Badge
                        badgeContent={paymentAcceptedRequests.length}
                        color="success"
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "static",
                            transform: "none",
                            mt: 0.5,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                }
                disabled={interestLoading || tabLoading}
              />
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1,
                    }}
                  >
                    <PauseCircleIcon />
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        py: 1,
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        On Hold
                      </Typography>
                      <Badge
                        badgeContent={holdRequests.length}
                        color="warning"
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "static",
                            transform: "none",
                            mt: 0.5,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                }
                disabled={interestLoading || tabLoading}
              />
              <Tab
                label={
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      gap: 1.5,
                      py: 1,
                    }}
                  >
                    <EventBusyIcon color="error" />{" "}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 1.5,
                        py: 1,
                      }}
                    >
                      <Typography variant="body2" fontWeight={600}>
                        Expired
                      </Typography>
                      <Badge
                        badgeContent={expiredAcceptedRequests.length}
                        color="warning"
                        sx={{
                          "& .MuiBadge-badge": {
                            position: "static",
                            transform: "none",
                            mt: 0.5,
                          },
                        }}
                      />
                    </Box>
                  </Box>
                }
                disabled={interestLoading || tabLoading}
              />
            </Tabs>
          </Paper>

          {/* Tab Content */}
          <Box sx={{ mt: 3 }}>
            {interestLoading || tabLoading ? (
              <Grid container spacing={3}>
                {[1, 2, 3, 4, 5, 6].map((item) => (
                  <SkeletonCard key={item} />
                ))}
              </Grid>
            ) : getFilteredData().length === 0 ? (
              <Paper
                elevation={0}
                sx={{
                  py: 8,
                  borderRadius: 2,
                  bgcolor: "white",
                  border: "1px solid #e5e7eb",
                }}
              >
                <Box
                  sx={{
                    textAlign: "center",
                    maxWidth: 500,
                    mx: "auto",
                    px: 3,
                  }}
                >
                  <SearchIcon sx={{ fontSize: 80, color: "#cbd5e1", mb: 2 }} />
                  <Typography
                    variant="h5"
                    sx={{
                      fontWeight: 700,
                      color: "#1e293b",
                      mt: 3,
                      mb: 1,
                    }}
                  >
                    {noDataInfo.title}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.secondary"
                    sx={{ mb: 3, lineHeight: 1.6 }}
                  >
                    {noDataInfo.description}
                  </Typography>
                  {searchQuery && (
                    <Button
                      variant="contained"
                      onClick={handleClearSearch}
                      sx={{
                        bgcolor: "var(--owner-primary)",
                        px: 3,
                        py: 1,
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": {
                          bgcolor: "#5568d3",
                        },
                      }}
                    >
                      Clear Search
                    </Button>
                  )}
                </Box>
              </Paper>
            ) : (
              <Fade in={true} timeout={600}>
                <Grid container spacing={3}>
                  {activeTab === 0 &&
                    getFilteredData().map((req) =>
                      renderRequestCard(req, "pending")
                    )}
                  {activeTab === 1 &&
                    getFilteredData().map((req) =>
                      renderRequestCard(req, "paymentVerification")
                    )}
                  {activeTab === 2 &&
                    getFilteredData().map((req) =>
                      renderRequestCard(req, "moveIn")
                    )}
                  {activeTab === 3 &&
                    getFilteredData().map((req) =>
                      renderRequestCard(req, "rejected")
                    )}
                  {activeTab === 4 &&
                    getFilteredData().map((req) =>
                      renderRequestCard(req, "accepted")
                    )}
                  {activeTab === 5 &&
                    getFilteredData().map((req) =>
                      renderRequestCard(req, "hold")
                    )}
                  {activeTab === 6 &&
                    getFilteredData().map((req) =>
                      renderRequestCard(req, "expired")
                    )}
                </Grid>
              </Fade>
            )}
          </Box>
        </Container>

        {/* Action Dialog for Interest Requests */}
        <Dialog
          open={actionDialog.open}
          onClose={handleCloseActionDialog}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
            },
          }}
        >
          <DialogTitle sx={{ pb: 1 }}>
            <Typography variant="h6" fontWeight={700}>
              {actionDialog.action === "accepted"
                ? actionDialog.request?.status === "expired"
                  ? "Extend 2 Days"
                  : "Accept Request"
                : "Reject Request"}
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body1" sx={{ mb: 3, mt: 1 }}>
              {actionDialog.action === "accepted"
                ? `Are you sure you want to accept the request from ${actionDialog.request?.tenantName} for ${flatLabel(actionDialog.request)}? They will be notified to make payment.`
                : `Are you sure you want to reject the request from ${actionDialog.request?.tenantName} for ${flatLabel(actionDialog.request)}?`}
            </Typography>

            {actionDialog.action === "accepted" && (
              <Box sx={{ mb: 2 }}>
                <DatePicker
                  label="Payment Due Date"
                  value={dueDate}
                  onChange={(newValue) => setDueDate(newValue)}
                  minDate={dayjs()}
                  disablePast
                  disabled={actionDialog.request?.status == "expired"}
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      required: true,
                      error: !dueDate,
                      helperText: !dueDate ? "Due date is required" : "",
                    },
                  }}
                />
              </Box>
            )}

            <TextField
              fullWidth
              multiline
              rows={3}
              label="Response Message (Optional)"
              placeholder={
                actionDialog.action === "accepted"
                  ? "e.g., Please make payment within 3 days to confirm booking..."
                  : "e.g., Sorry, the flat has already been rented..."
              }
              value={responseMessage}
              inputProps={{ maxLength: 50 }}
              onChange={(e) => setResponseMessage(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 2,
                },
              }}
            />
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button
              onClick={handleCloseActionDialog}
              disabled={actionLoading}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color={actionDialog.action === "accepted" ? "success" : "error"}
              onClick={handleConfirmInterestAction}
              disabled={actionLoading}
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                px: 3,
              }}
            >
              {actionLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                "Confirm"
              )}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Receipt View Dialog */}
        <Dialog
          open={receiptDialog.open}
          onClose={handleCloseReceiptDialog}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              borderRadius: 3,
            },
          }}
        >
          <DialogTitle sx={{ pb: 1 }}>
            <Typography variant="h6" fontWeight={700}>
              Payment Receipt
            </Typography>
            {receiptDialog.request && (
              <Typography variant="body2" color="text.secondary">
                {receiptDialog.request.tenantName} • {flatLabel(receiptDialog.request)}
              </Typography>
            )}
          </DialogTitle>
          <DialogContent>
            {receiptDialog.request?.receiptImage && (
              <Box
                component="img"
                src={receiptDialog.request.receiptImage}
                alt="Payment Receipt"
                sx={{
                  width: "100%",
                  maxHeight: "70vh",
                  objectFit: "contain",
                  borderRadius: 2,
                }}
              />
            )}
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 3 }}>
            <Button
              onClick={handleCloseReceiptDialog}
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
              disabled={actionLoading}
            >
              Close
            </Button>
            <Button
              variant="outlined"
              startIcon={<DownloadIcon />}
              onClick={() =>
                downloadReceipt(receiptDialog.request?.receiptImage)
              }
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              Download
            </Button>
            <Button
              variant="contained"
              color="success"
              onClick={() => handleVerifyPayment(receiptDialog.request, true)}
              disabled={actionLoading}
              startIcon={
                actionLoading ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <VerifiedIcon />
                )
              }
              sx={{ borderRadius: 2, textTransform: "none", fontWeight: 600 }}
            >
              {actionLoading ? "Processing..." : "Verify Payment"}
            </Button>
            <Button
              variant="outlined"
              color="error"
              onClick={() => handleVerifyPayment(receiptDialog.request, false)}
              disabled={actionLoading}
              startIcon={
                actionLoading ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <CancelIcon />
                )
              }
              sx={{
                borderRadius: 2,
                textTransform: "none",
                fontWeight: 600,
                borderWidth: 2,
              }}
            >
              {actionLoading ? "Processing..." : "Reject"}
            </Button>
          </DialogActions>
        </Dialog>

        {/* Tenant Detail Dialog */}
        <TenantDetailDialog />

        {/* Bank Details Modal */}
        <BankDetailsModal
          open={bankModalOpen}
          onClose={() => {
            setBankModalOpen(false);
            setPendingAcceptRequest(null);
          }}
          onSuccess={handleBankDetailsSuccess}
          tenantName={pendingAcceptRequest?.tenantName || "Tenant"}
          flatName={pendingAcceptRequest ? flatLabel(pendingAcceptRequest) : "Property"}
          advanceAmount={pendingAcceptRequest?.advanceAmount}
        />
      </div>
    </LocalizationProvider>
  );
}
